import React, {useEffect} from 'react';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {
  PaypalPaymentStatusContextProvider,
} from '../../contexts/PaypalPaymentStatusContext';
import PageHeader from '../../../../common/components/ui/PageHeader';
import FooterLogo from "../../../../common/components/ui/FooterLogo";
import SectionPanel from "../../../../common/components/ui/SectionPanel";
import Message from "../../components/Message/Message";

const PaypalPaymentStatus = () => {
  const {setPageTitle} = useGlobalContext();
  useEffect(() => {
    setPageTitle((
      <PageHeader
        id={'payPalPaymentStatus-page-header'}
        defaultMessage={'PayPal payment status'}
        showLogo={true}
      />
    ));
  }, []);

  return (
    <PaypalPaymentStatusContextProvider>
      <SectionPanel>
        <Message/>
      </SectionPanel>
      <FooterLogo/>
    </PaypalPaymentStatusContextProvider>
  );
};

export default PaypalPaymentStatus;
